module.exports = __webpack_public_path__ + "img/17.d3e5e27c.png";